import React, { createContext, useContext } from "react";
import { Empty, List } from "antd";
import { Observer, observer } from "mobx-react-lite";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { toJS } from "mobx";

import { MessageBar, MessageBarType } from "@fluentui/react";
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoErrorLogs = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  return (
    <Observer>
      {() => (
        <List
          itemLayout="horizontal"
          locale={{
            emptyText: (
              <Empty description={`No upload errors,everything looks great.`} />
            ),
          }}
          dataSource={ebendoDailyProductionStore.uploadErrors.map((x) =>
            toJS(x)
          )}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                description={
                  <MessageBar
                    messageBarType={
                      item.type === "Error"
                        ? MessageBarType.error
                        : MessageBarType.warning
                    }
                  >
                    {item.message}
                  </MessageBar>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Observer>
  );
});

